export const round2 = (value: number) => {
  return Math.round(value * 1e2) / 1e2;
};
